import * as React from 'react';

export function renderIf (v: any, suffix: any, transform?: (v: any) => any) {
  const vv = transform ? transform(v) : v

  return vv ? (<>
    {vv}
    {suffix}
  </>) : null
}